import { NgModule } from '@angular/core';
import { SessionModule } from '@spaq/modules/session';
import { MessageStateModule } from '@spaq/shared/components/message-state';
import { SharedCommonModule } from '@spaq/shared';
import { AuthCodeComponent } from './components';

@NgModule({
	imports: [SharedCommonModule, SessionModule, MessageStateModule],
	declarations: [AuthCodeComponent],
	exports: [AuthCodeComponent]
})
export class AuthModule {}
